<template>
  <div class="menu" :class="[{active: isActive}]" ref="menuRef">
    <svg @click="closeModal" class="menu__cross" fill="#000" width="40" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.8,16l5.5-5.5c0.8-0.8,0.8-2,0-2.8l0,0C24,7.3,23.5,7,23,7c-0.5,0-1,0.2-1.4,0.6L16,13.2l-5.5-5.5  c-0.8-0.8-2.1-0.8-2.8,0C7.3,8,7,8.5,7,9.1s0.2,1,0.6,1.4l5.5,5.5l-5.5,5.5C7.3,21.9,7,22.4,7,23c0,0.5,0.2,1,0.6,1.4  C8,24.8,8.5,25,9,25c0.5,0,1-0.2,1.4-0.6l5.5-5.5l5.5,5.5c0.8,0.8,2.1,0.8,2.8,0c0.8-0.8,0.8-2.1,0-2.8L18.8,16z"/>
    </svg>
    <nav class="menu__nav">
      <p class="menu__nav-item" @click="scrollTo('services', 'home')">Services</p>
      <p class="menu__nav-item" @click="scrollTo('about', 'home')">About Us</p>
      <p class="menu__nav-item" @click="scrollTo('partner', 'home')">Partner up</p>
      <p class="menu__nav-item" @click="scrollTo('benefits', 'home')">Benefits</p>
      <button class="menu__nav-button" @click="scrollTo('contact', 'home')">Let's Talk</button>
    </nav>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {onClickOutside} from "@vueuse/core";
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";

const emit = defineEmits(['close-modal'])

const props = defineProps({
  isActive: Boolean
})
const closeModal = () => {
  emit('close-modal');
}

const router = useRouter()
const route = useRoute()

const menuRef = ref(null)
onClickOutside(menuRef, () => closeModal())

const scrollTo = (id, routeName) => {
  closeModal();
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({
      name: routeName
    }).then(scroll(id, 500));
  }
}
</script>

<style lang="scss" scoped>
.menu {
  cursor: default;
  display: none;
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  width: 200px;
  height: 100vh;
  background-color: #f3f3f3;
  visibility: hidden;
  transform: translateX(100%);
  transition: transform 0.3s, visibility 0s 0.3s;
  flex-direction: column;
  align-items: center;
  border-left: 1px solid #E5E5E5;
  box-shadow: 0 4px 11.6px 0 rgba(0, 0, 0, 0.20);

  &.active {
    visibility: visible;
    transform: translateX(0);
    transition: transform 0.3s;
  }

  &__cross {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  &__nav {
    padding-top: 75px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    &-item {
      text-align: right;
      cursor: pointer;
      transition: 0.2s;
      color: #252641;
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0.44px;

      @include hover {
        color: #0e0f1a;
      }
    }

    &-button {
      cursor: pointer;
      border-radius: 80px;
      background-color: #F48C06;
      padding: 6px 40px;
      transition: 0.2s;

      color: $white;
      font-size: 16px;
      font-weight: 600;

      @include hover {
        background-color: #ff9f28;
      }
    }
  }
}

@media (max-width: 1100px) {
  .menu {
    display: flex;
  }
}
</style>